import { useEffect, useState } from 'react';
import { carregarJornadaConfig } from '../lib/appConfig';
import { useAuth } from '../contexts/AuthContext';

export default function useAppFeatures() {
  const { user } = useAuth();
  const [features, setFeatures] = useState({ jornada: false, carregando: true });
  useEffect(() => {
    let active = true;
    carregarJornadaConfig().then(config => {
      const jornada = Boolean(config.ativoTodos || (user?.id && config.alunaIds.includes(user.id)));
      if (active) setFeatures({ jornada, carregando: false });
    });
    return () => { active = false; };
  }, [user?.id]);
  return features;
}
